/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListAltIcon from '@material-ui/icons/ListAltSharp';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputIcon from '@material-ui/icons/InputRounded';
import PublicIcon from '@material-ui/icons/PublicRounded';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import LabelIcon from '@material-ui/icons/Label';
import DataUsageIcon from '@material-ui/icons/DataUsageRounded';
import DnsIcon from '@material-ui/icons/DnsRounded';
import TableChartIcon from '@material-ui/icons/TableChartRounded';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ExtensionIcon from '@material-ui/icons/Extension';
import SailingIcon from '@mui/icons-material/Sailing';
import FlightIcon from '@mui/icons-material/Flight';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssistantIcon from '@material-ui/icons/Assistant';

import { Grid, makeStyles } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import QCXCollapse from '../../shared-components/collapse/QCXCollapse';
import QCXListItemText from '../../shared-components/list-item-text/QCXListItemText';
import QCXListItemIcon from '../../shared-components/list-item-icon/QCXListItemIcon';
import QCXListItem from '../../shared-components/list-item/QCXListItem';
import QCXList from '../../shared-components/list/QCXList';
import QCXListMenu from '../../shared-components/list-menu/QCXListMenu';
import QCXFocusLock from '../focus-lock/QCXFocusLock';
import {
  ACESSOS_ACESSOS_TABELA_ADUANEIRA_BASE_ROLE_NAME,
  ACESSOS_CADASTROS_FINANCEIROS_BASE_ROLE_NAME,
  ACESSOS_CADASTROS_GERAIS_BASE_ROLE_NAME,
  ACESSOS_CADASTROS_OPERACIONAIS_BASE_ROLE_NAME,
  ACESSOS_IMPORTACAO_BASE_ROLE_NAME,
  ACESSOS_EXPORTACAO_BASE_ROLE_NAME,
  ACESSOS_FINANCEIRO_BASE_ROLE_NAME,
  ACESSOS_ASSESSORIA_BASE_ROLE_NAME,
  ACESSOS_COMERCIAL_BASE_ROLE_NAME,
  ACESSOS_INTEGRACAO_BASE_ROLE_NAME,
  ACESSOS_RELATORIOS_BASE_ROLE_NAME,
  ACESSOS_AGENCIAMENTO_BASE_ROLE_NAME,
} from '../perfil/perfil-utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  grow: {
    alignSelf: 'bottom',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  activeNavLink: {
    fontWeight: 'bold',
  },
}));

export default function QCXLateralMenu({ disableFocusLock, authInfo = {} }) {
  const { t } = useTranslation();

  const userHasAnyRole = (mainRoles = []) =>
    authInfo.roles?.some((role) => mainRoles.find((item) => role.startsWith(item)));
  const userHasAnyAccessModules = (mainAccess = []) =>
    authInfo.accessModules?.some((access) => mainAccess.find((item) => access === item));
  const classes = useStyles();

  // const [enterSubmenuTransition, setEnterSubmenuTransition] = useState(false);
  const [openRegistrationsSubmenu, setOpenRegistrationsSubmenu] = useState(false);

  const [openRegistrationsSubmenuImportacao, setOpenRegistrationsSubmenuImportacao] = useState(false);
  const [openRegistrationsSubmenuPricing, setOpenRegistrationsSubmenuPricing] = useState(false);
  const [activeDesembaracoSubmenu, setActiveDesembaracoSubmenu] = useState(false);
  const [activeAgenciamentoSubmenu, setActiveAgenciamentoSubmenu] = useState(false);
  const [openRegistrationsSubmenuExportacao, setOpenRegistrationsSubmenuExportacao] = useState(false);
  const [activeAgenciamentoExportacaoSubmenu, setActiveAgenciamentoExportacaoSubmenu] = useState(false);
  const [activeDesembaracoExportacaoSubmenu, setActiveDesembaracoExportacaoSubmenu] = useState(false);



  const [activeGeneralRegistrationsSubmenu, setActiveGeneralRegistrationsSubmenu] = useState(false);
  const [activeOperationalRegistrationsSubmenu, setActiveOperationalRegistrationsSubmenu] = useState(false);
  const [activeImportacaoSubmenu, setActiveImportacaoSubmenu] = useState(false);
  const [activeExportacaoSubmenu, setActiveExportacaoSubmenu] = useState(false);
  const [activeFinancialRegistrationsSubmenu, setActiveFinancialRegistrationsSubmenu] = useState(false);
  const [activeFinancialSubmenu, setActiveFinancialSubmenu] = useState(false);
  const [activeComercialSubmenu, setActiveComercialSubmenu] = useState(false);
  const [activeIntegracaoSubmenu, setActiveIntegracaoSubmenu] = useState(false);
  const [activeRelatoriosSubmenu, setActiveRelatoriosSubmenu] = useState(false);
  const [activeAssessoriaSubMenu, setActiveAssessoriaSubMenu] = useState(false);
  const [activeTarifarioPricingSubMenu, setActiveTarifarioPricingSubMenu] = useState(false);

  const [openAgenciamentoImportacao, setOpenAgenciamentoImportacao] = useState(false);
  const [openAgenciamentoExportacao, setOpenAgenciamentoExportacao] = useState(false);

  const toggleAgenciamentoImportacao = useCallback(() => {
    setOpenAgenciamentoImportacao((prev) => !prev);
  }, []);

  const toggleAgenciamentoExportacao = useCallback(() => {
    setOpenAgenciamentoExportacao((prev) => !prev);
  }, []);


  const toggleRegistrationsSubmenu = useCallback(() => {
    setOpenRegistrationsSubmenu(!openRegistrationsSubmenu);
  }, [openRegistrationsSubmenu, setOpenRegistrationsSubmenu]);


  const toggleRegistrationsSubmenuPricing = useCallback(() => {
    setOpenRegistrationsSubmenuPricing(!openRegistrationsSubmenuPricing);
  }, [openRegistrationsSubmenuPricing, setOpenRegistrationsSubmenuPricing]);

  const toggleRegistrationsSubmenuImportacao = useCallback(() => {
    setOpenRegistrationsSubmenuImportacao(!openRegistrationsSubmenuImportacao);
  }, [openRegistrationsSubmenuImportacao, setOpenRegistrationsSubmenuImportacao]);

  const toggleRegistrationsSubmenuExportacao = useCallback(() => {
    setOpenRegistrationsSubmenuExportacao(!openRegistrationsSubmenuExportacao);
  }, [openRegistrationsSubmenuExportacao, setOpenRegistrationsSubmenuExportacao]);


  const isActiveGeneralRegistrationsSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveGeneralRegistrationsSubmenu(active);
      return active;
    }, [setActiveGeneralRegistrationsSubmenu]);

  const isActiveTarifarioPricingSubMenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveTarifarioPricingSubMenu(active);
      return active;
    }, [setActiveTarifarioPricingSubMenu]);

  const isActiveDesembaracoSubmenu = useCallback((match) => {

    const active = !!match;

    setActiveDesembaracoSubmenu(active);

    return active;

  }, [setActiveDesembaracoSubmenu]);

  const isActiveOperationalRegistrationsSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveOperationalRegistrationsSubmenu(active);
      return active;
    }, [setActiveOperationalRegistrationsSubmenu]);

  const isActiveImportacaoSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveImportacaoSubmenu(active);
      return active;
    },
    [setActiveImportacaoSubmenu]
  );

  const isActiveAgenciamentoSubmenu = useCallback((match) => {
    const active = !!match;
    setActiveAgenciamentoSubmenu(active);
    return active;
  }, [setActiveAgenciamentoSubmenu])

  const isActiveAgenciamentoExportacaoSubmenu = useCallback((match) => {
    const active = !!match;
    setActiveAgenciamentoExportacaoSubmenu(active);
    return active;
  }, [setActiveAgenciamentoExportacaoSubmenu])

  const isActiveDesembaracoExportacaoSubmenu = useCallback((match) => {

    const active = !!match;

    setActiveDesembaracoExportacaoSubmenu(active);

    return active;

  }, [setActiveDesembaracoExportacaoSubmenu]);



  const isActiveExportacaoSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveExportacaoSubmenu(active);
      return active;
    },
    [setActiveExportacaoSubmenu]
  );

  const isActiveFinancialRegistrationsSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveFinancialRegistrationsSubmenu(active);
      return active;
    },
    [setActiveFinancialRegistrationsSubmenu]
  );

  const isActiveFinancialSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveFinancialSubmenu(active);
      return active;
    }, [setActiveFinancialSubmenu]);

  const isActiveComercialSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveComercialSubmenu(active);
      return active;
    }, [setActiveComercialSubmenu]);

  const isActiveIntegracaoSubmenu = useCallback(
    (match) => {
      const active = !!match;
      setActiveIntegracaoSubmenu(active);
      return active;
    }, [setActiveIntegracaoSubmenu]);

  // isActiveRegistrationsSubmenu
  const isActiveRelatoriosSubmenu = useCallback((match) => {
    const active = !!match;
    setActiveRelatoriosSubmenu(active);
    return active;
  }, [setActiveRelatoriosSubmenu]);

  const isActiveAssessoriaSubmenu = useCallback((match) => {
    const active = !!match;
    setActiveAssessoriaSubMenu(active);
    return active;
  }, [setActiveAssessoriaSubMenu]);

  const expandComponent = useMemo(() => {
    if (
      !(
        activeGeneralRegistrationsSubmenu ||
        activeFinancialRegistrationsSubmenu ||
        activeOperationalRegistrationsSubmenu
      )
    ) {
      return openRegistrationsSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    }
    return undefined;
  }, [
    openRegistrationsSubmenu,
    activeGeneralRegistrationsSubmenu,
    activeFinancialRegistrationsSubmenu,
    activeOperationalRegistrationsSubmenu,
  ]);

  const expandComponentImportacao = useMemo(() =>
    openRegistrationsSubmenuImportacao ? <ExpandLessIcon /> : <ExpandMoreIcon />,
    [openRegistrationsSubmenuImportacao]
  );


  const expandComponentExportacao = useMemo(() =>
    openRegistrationsSubmenuExportacao ? <ExpandLessIcon /> : <ExpandMoreIcon />,
    [setOpenRegistrationsSubmenuExportacao]
  );

  const expandComponentPricing = useMemo(() =>
    openRegistrationsSubmenuPricing ? <ExpandLessIcon /> : <ExpandMoreIcon />,
    [openRegistrationsSubmenuPricing]
  );

  return (
    <Grid container style={{ minWidth: '100%', minHeight: '100%' }} alignContent="space-between">
      <QCXFocusLock disabled={disableFocusLock}>
        <Grid item style={{ minWidth: '100%' }}>
          <QCXListMenu>
            {/* CADASTRO */}
            <QCXListItem
              button
              key="cadastros"
              hidden={
                !userHasAnyRole([
                  ...ACESSOS_ACESSOS_TABELA_ADUANEIRA_BASE_ROLE_NAME,
                  ...ACESSOS_CADASTROS_FINANCEIROS_BASE_ROLE_NAME,
                  ...ACESSOS_CADASTROS_GERAIS_BASE_ROLE_NAME,
                  ...ACESSOS_CADASTROS_OPERACIONAIS_BASE_ROLE_NAME,
                  ...ACESSOS_FINANCEIRO_BASE_ROLE_NAME,
                ]) || !userHasAnyAccessModules(['CADASTROS'])
              }
              onClick={toggleRegistrationsSubmenu}
            >
              <QCXListItemIcon>
                <ListAltIcon color="primary" />
              </QCXListItemIcon>
              <QCXListItemText
                primary={t('com.muralis.qcx.cadastros')}
                isActive={
                  activeGeneralRegistrationsSubmenu ||
                  activeFinancialRegistrationsSubmenu ||
                  activeOperationalRegistrationsSubmenu
                }
              />
              {expandComponent}
            </QCXListItem>

            <QCXCollapse
              in={
                openRegistrationsSubmenu ||
                activeGeneralRegistrationsSubmenu ||
                activeFinancialRegistrationsSubmenu ||
                activeOperationalRegistrationsSubmenu
              }
              timeout="auto"
              enter={openRegistrationsSubmenu}
            >
              <QCXList component="div" disablePadding>
                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloCadastrosGerais')}
                  isActive={isActiveGeneralRegistrationsSubmenu}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_GERAIS_BASE_ROLE_NAME)}
                  selected={activeGeneralRegistrationsSubmenu}
                >
                  <QCXListItemIcon>
                    <LabelIcon color={activeGeneralRegistrationsSubmenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText primary={t('com.muralis.qcx.gerais')} isActive={activeGeneralRegistrationsSubmenu} />
                </QCXListItem>
                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloCadastrosOperacionais')}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_OPERACIONAIS_BASE_ROLE_NAME)}
                  isActive={isActiveOperationalRegistrationsSubmenu}
                  selected={activeOperationalRegistrationsSubmenu}
                >
                  <QCXListItemIcon>
                    <DnsIcon color={activeOperationalRegistrationsSubmenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText
                    primary={t('com.muralis.qcx.operacionais')}
                    isActive={activeOperationalRegistrationsSubmenu}
                  />
                </QCXListItem>
                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloCadastrosFinanceiros')}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_FINANCEIROS_BASE_ROLE_NAME)}
                  isActive={isActiveFinancialRegistrationsSubmenu}
                  selected={activeFinancialRegistrationsSubmenu}
                >
                  <QCXListItemIcon>
                    <DataUsageIcon color={activeFinancialRegistrationsSubmenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText
                    primary={t('com.muralis.qcx.financeiro.labelPlural')}
                    isActive={activeFinancialRegistrationsSubmenu}
                  />
                </QCXListItem>
                <QCXListItem
                  button
                  disabled
                  className={classes.nested}
                  hidden
                // hidden={!userHasAnyRole(ACESSOS_ACESSOS_TABELA_ADUANEIRA_BASE_ROLE_NAME)}
                >
                  <QCXListItemIcon>
                    <TableChartIcon color="primary" />
                  </QCXListItemIcon>
                  <QCXListItemText primary={t('com.muralis.qcx.tabelasAduaneiras')} />
                </QCXListItem>
              </QCXList>
            </QCXCollapse>

            {/* ASSESSORIA */}
            <QCXListItem
              button
              key="assessoria"
              component={NavLink}
              to="/assessoria"
              hidden={!userHasAnyRole(ACESSOS_ASSESSORIA_BASE_ROLE_NAME)}
              isActive={isActiveAssessoriaSubmenu}
              selected={activeAssessoriaSubMenu}
            >
              <QCXListItemIcon>
                <AssistantIcon color={activeAssessoriaSubMenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText primary="Assessoria" isActive={activeAssessoriaSubMenu} />
            </QCXListItem>

            {/* PRICING   */}
            <QCXListItem
              button
              key="pricing"
              hidden={
                !userHasAnyRole([
                  ...ACESSOS_AGENCIAMENTO_BASE_ROLE_NAME
                ])
              }
              onClick={toggleRegistrationsSubmenuPricing}
            >
              <QCXListItemIcon>
                <ListAltIcon color="primary" />
              </QCXListItemIcon>
              <QCXListItemText
                primary={t('com.muralis.qcx.pricing')}
                isActive={activeTarifarioPricingSubMenu}
              />
              {expandComponentPricing}
            </QCXListItem>

            <QCXCollapse
              in={
                openRegistrationsSubmenuPricing
              }
              timeout="auto"
              enter={toggleRegistrationsSubmenuPricing}
            >
              <QCXList component="div" disablePadding>

                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloPricingTarifario')}
                  isActive={isActiveTarifarioPricingSubMenu}
                  hidden={!userHasAnyRole(ACESSOS_AGENCIAMENTO_BASE_ROLE_NAME)}
                  selected={activeTarifarioPricingSubMenu}
                >
                  <QCXListItemIcon>
                    <LabelIcon color={activeTarifarioPricingSubMenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText primary={t('com.muralis.qcx.tarifarios')} isActive={activeTarifarioPricingSubMenu} />


                </QCXListItem>

              </QCXList>
            </QCXCollapse>


            {/* IMPORTAÇÃO */}
            <QCXListItem
              button
              key="modulo-importacao"
              hidden={
                !userHasAnyRole(ACESSOS_IMPORTACAO_BASE_ROLE_NAME) || !userHasAnyAccessModules(['IMPORTACAO'])
              }
              onClick={toggleRegistrationsSubmenuImportacao}
            >
              <QCXListItemIcon>
                <ListAltIcon color="primary" />
              </QCXListItemIcon>

              <QCXListItemText
                primary={t('com.muralis.qcx.importacao.label')}
                isActive={
                  activeAgenciamentoSubmenu ||
                  activeDesembaracoSubmenu
                }
              />
              {expandComponentImportacao}

            </QCXListItem>

            <QCXCollapse
              in={
                openRegistrationsSubmenuImportacao ||
                activeAgenciamentoSubmenu ||
                activeDesembaracoSubmenu
              }
              timeout="auto"
              enter={openRegistrationsSubmenuImportacao}
            >
              <QCXList component="div" disablePadding>
                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloImportacao')}
                  isActive={isActiveDesembaracoSubmenu}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_GERAIS_BASE_ROLE_NAME)}
                  selected={activeDesembaracoSubmenu}
                >
                  <QCXListItemIcon>
                    <LabelIcon color={activeDesembaracoSubmenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText primary={t('com.muralis.qcx.desembaraco')} isActive={activeGeneralRegistrationsSubmenu} />
                </QCXListItem>


                {/* AGENCIAMENTO (pai) */}
                <QCXListItem
                  button
                  className={classes.nested}
                  onClick={toggleAgenciamentoImportacao}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_OPERACIONAIS_BASE_ROLE_NAME)}
                >
                  <QCXListItemIcon>
                    <DnsIcon color={(openAgenciamentoImportacao || activeAgenciamentoSubmenu) ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>

                  <QCXListItemText
                    primary="Agenciamento"
                    isActive={openAgenciamentoImportacao || activeAgenciamentoSubmenu}
                  />

                  {(openAgenciamentoImportacao || activeAgenciamentoSubmenu) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </QCXListItem>

                <QCXCollapse
                  in={openAgenciamentoImportacao || activeAgenciamentoSubmenu}
                  timeout="auto"
                  enter={openAgenciamentoImportacao}
                >
                  <QCXList component="div" disablePadding>
                    <QCXListItem
                      button
                      component={NavLink}
                      className={classes.nested}
                      style={{ paddingLeft: 48 }}
                      to="/importacao/agenciamento/maritimo"
                    >
                      <SailingIcon color={(openAgenciamentoImportacao || activeAgenciamentoSubmenu) ? 'secondary' : 'primary'} />
                      <QCXListItemText primary="Marítimo" />
                    </QCXListItem>

                    <QCXListItem
                      button
                      component={NavLink}
                      className={classes.nested}
                      style={{ paddingLeft: 48 }}
                      to="/importacao/agenciamento/aereo"
                    >
                      <FlightIcon color={(openAgenciamentoImportacao || activeAgenciamentoSubmenu) ? 'secondary' : 'primary'} />
                      <QCXListItemText primary="Aéreo" />
                    </QCXListItem>
                  </QCXList>
                </QCXCollapse>
              </QCXList>
            </QCXCollapse>


            {/* EXPORTACAO */}
            <QCXListItem
              button
              key="modulo-exportacao"
              hidden={!userHasAnyRole(ACESSOS_EXPORTACAO_BASE_ROLE_NAME) || !userHasAnyAccessModules(['EXPORTACAO'])}
              onClick={toggleRegistrationsSubmenuExportacao}
            >
              <QCXListItemIcon>
                <PublicIcon color={activeExportacaoSubmenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText
                primary={t('com.muralis.qcx.exportacao.label')}
                isActive={activeExportacaoSubmenu}
              />

              {expandComponentExportacao}
            </QCXListItem>

            <QCXCollapse
              in={
                openRegistrationsSubmenuExportacao
              }
              timeout="auto"
              enter={openRegistrationsSubmenuExportacao}
            >
              <QCXList component="div" disablePadding>
                <QCXListItem
                  button
                  component={NavLink}
                  className={classes.nested}
                  to={t('com.muralis.qcx.url.moduloExportacao')}
                  isActive={isActiveDesembaracoExportacaoSubmenu}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_GERAIS_BASE_ROLE_NAME)}
                  selected={activeDesembaracoExportacaoSubmenu}
                >
                  <QCXListItemIcon>
                    <LabelIcon color={activeDesembaracoExportacaoSubmenu ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>
                  <QCXListItemText primary={t('com.muralis.qcx.desembaraco')} isActive={activeDesembaracoExportacaoSubmenu} />
                </QCXListItem>


                {/* AGENCIAMENTO (pai) */}
                <QCXListItem
                  button
                  className={classes.nested}
                  onClick={toggleAgenciamentoExportacao}
                  hidden={!userHasAnyRole(ACESSOS_CADASTROS_OPERACIONAIS_BASE_ROLE_NAME)}
                >
                  <QCXListItemIcon>
                    <DnsIcon color={(openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu) ? 'secondary' : 'primary'} />
                  </QCXListItemIcon>

                  <QCXListItemText
                    primary="Agenciamento"
                    isActive={openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu}
                  />

                  {(openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </QCXListItem>

                <QCXCollapse
                  in={openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu}
                  timeout="auto"
                  enter={openAgenciamentoExportacao}
                >
                  <QCXList component="div" disablePadding>
                    <QCXListItem
                      button
                      component={NavLink}
                      className={classes.nested}
                      style={{ paddingLeft: 48 }}
                      to="/exportacao/agenciamento/maritimo"
                    >
                      <QCXListItemIcon>
                        <SailingIcon color={(openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu) ? 'secondary' : 'primary'} />
                      </QCXListItemIcon>
                      <QCXListItemText primary="Marítimo" />
                    </QCXListItem>

                    <QCXListItem
                      button
                      component={NavLink}
                      className={classes.nested}
                      style={{ paddingLeft: 48 }}
                      to="/exportacao/agenciamento/aereo"
                    >
                      <QCXListItemIcon>
                        <FlightIcon color={(openAgenciamentoExportacao || activeAgenciamentoExportacaoSubmenu) ? 'secondary' : 'primary'} />
                      </QCXListItemIcon>
                      <QCXListItemText primary="Aéreo" />
                    </QCXListItem>
                  </QCXList>
                </QCXCollapse>
              </QCXList>

            </QCXCollapse>

            {/* FINANCEIRO */}
            <QCXListItem
              button
              key="financeiro"
              component={NavLink}
              to={t('com.muralis.qcx.url.moduloFinanceiro')}
              hidden={!userHasAnyRole(ACESSOS_FINANCEIRO_BASE_ROLE_NAME) || !userHasAnyAccessModules(['FINANCEIRO'])}
              isActive={isActiveFinancialSubmenu}
              selected={activeFinancialSubmenu}
            >
              <QCXListItemIcon>
                <AccountBalanceIcon color={activeFinancialSubmenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText primary={t('com.muralis.qcx.financeiro.label')} isActive={activeFinancialSubmenu} />
            </QCXListItem>
            <QCXListItem
              button
              key="comercial"
              component={NavLink}
              to={t('com.muralis.qcx.url.moduloComercial')}
              hidden={!userHasAnyRole(ACESSOS_COMERCIAL_BASE_ROLE_NAME) || !userHasAnyAccessModules(['COMERCIAL'])}
              isActive={isActiveComercialSubmenu}
              selected={activeComercialSubmenu}
            >
              <QCXListItemIcon>
                <MonetizationOnIcon color={activeComercialSubmenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText primary={t('com.muralis.qcx.comercial.label')} isActive={activeComercialSubmenu} />
            </QCXListItem>
            <QCXListItem
              button
              key="integracao"
              component={NavLink}
              to="/integracao"
              hidden={!userHasAnyRole(ACESSOS_INTEGRACAO_BASE_ROLE_NAME) || !userHasAnyAccessModules(['INTEGRACAO'])}
              isActive={isActiveIntegracaoSubmenu}
              selected={activeIntegracaoSubmenu}
            >
              <QCXListItemIcon>
                <ExtensionIcon color={activeIntegracaoSubmenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText primary="Integração" isActive={activeIntegracaoSubmenu} />
            </QCXListItem>
            <QCXListItem
              button
              key="relatorios"
              component={NavLink}
              to="/relatorios"
              hidden={!userHasAnyRole(ACESSOS_RELATORIOS_BASE_ROLE_NAME) || !userHasAnyAccessModules(['RELATORIOS'])}
              isActive={isActiveRelatoriosSubmenu}
              selected={activeRelatoriosSubmenu}
            >
              <QCXListItemIcon>
                <AssessmentIcon color={activeRelatoriosSubmenu ? 'secondary' : 'primary'} />
              </QCXListItemIcon>
              <QCXListItemText primary="Relatórios" isActive={activeRelatoriosSubmenu} />
            </QCXListItem>
          </QCXListMenu>
        </Grid>
      </QCXFocusLock>
    </Grid>
  );
}
